import React, { Component } from 'react';
import { Checkbox } from 'antd';
import cx from 'classnames';
import CheckBox from '../CheckBox';

class RadioGroupForm extends Component {
  render() {
    const { className, list, onChange, ...res } = this.props;

    return (
      <Checkbox.Group className={cx('amondz-checkbox-group', className)} onChange={onChange} {...res}>
        {list.map((data) => {
          return <CheckBox key={data.id} value={data.id} onChange={onChange} text={data.name} />;
        })}
      </Checkbox.Group>
    );
  }
}

export default RadioGroupForm;
